/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navbar_Nav_PlatformInputs */

const es_navbar_nav_platform = /** @type {(inputs: Navbar_Nav_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataforma`)
};

const en_navbar_nav_platform = /** @type {(inputs: Navbar_Nav_PlatformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

/**
* | output |
* | --- |
* | "Platform" |
*
* @param {Navbar_Nav_PlatformInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const navbar_nav_platform = /** @type {((inputs?: Navbar_Nav_PlatformInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navbar_Nav_PlatformInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_navbar_nav_platform(inputs)
	return en_navbar_nav_platform(inputs)
});
export { navbar_nav_platform as "navbar.nav_platform" }